// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".UserProfile-module__profile___3uWs5 {\n  margin: 3rem auto;\n  text-align: center;\n}\n", "",{"version":3,"sources":["UserProfile.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;AACpB","file":"UserProfile.module.css","sourcesContent":[".profile {\n  margin: 3rem auto;\n  text-align: center;\n}\n"]}]);
// Exports
exports.locals = {
	"profile": "UserProfile-module__profile___3uWs5"
};
module.exports = exports;
